import { render, staticRenderFns } from "./CurrentCustomerInfo.vue?vue&type=template&id=46e44bd8&"
import script from "./CurrentCustomerInfo.vue?vue&type=script&lang=js&"
export * from "./CurrentCustomerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46e44bd8')) {
      api.createRecord('46e44bd8', component.options)
    } else {
      api.reload('46e44bd8', component.options)
    }
    module.hot.accept("./CurrentCustomerInfo.vue?vue&type=template&id=46e44bd8&", function () {
      api.rerender('46e44bd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/pay-box/components/CurrentCustomerInfo.vue"
export default component.exports